export const getTheme = appProps => {
    // Get device theme!
    return appProps.theme;
}

export const getLoaderColors = theme => {
    switch (theme) {
        case 'dark':
            return {
                primary: '#40496f',
                secondary: '#5f657d'
            };

        default:
            return {
                primary: '#f0f0f0',
                secondary: '#e0e0e0'
            };
    }
}
